import { useEffect, useState } from 'react';
import { formatDuration, formatEta } from '../utils/time';

interface UseElapsedTimeOptions {
  startedAt?: string | null;
  completedAt?: string | null;
  progressPercent?: number;
  estimatedRemainingSeconds?: number | null;
  isRunning?: boolean;
}

export function useElapsedTime({
  startedAt,
  completedAt,
  progressPercent,
  estimatedRemainingSeconds,
  isRunning = true,
}: UseElapsedTimeOptions) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!isRunning || completedAt) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [isRunning, completedAt]);

  const started = startedAt ? new Date(startedAt).getTime() : null;
  const completed = completedAt ? new Date(completedAt).getTime() : null;
  const endTime = completed || now;

  const elapsedSeconds =
    started && endTime >= started ? Math.floor((endTime - started) / 1000) : 0;

  const elapsedLabel = formatDuration(elapsedSeconds);
  const etaLabel =
    estimatedRemainingSeconds != null
      ? formatEta(estimatedRemainingSeconds)
      : progressPercent != null && progressPercent > 5 && progressPercent < 100
        ? formatEta(null)
        : '';

  const completedLabel = completedAt
    ? `Completed ${new Date(completedAt).toLocaleString()}`
    : '';

  return {
    elapsedSeconds,
    elapsedLabel,
    etaLabel,
    completedLabel,
  };
}
